import { getAboutData } from 'services/api/about';
import { IAboutDataResponse } from 'types/api-responses';
import { useData } from 'hooks/useData';

export const useAboutPageData = () =>
  useData<IAboutDataResponse['data']>(getAboutData);

// export function useAboutStateData(
//   setBioState?: Dispatch<SetStateAction<string>>,
//   setExperienceState?: Dispatch<SetStateAction<IExperience[]>>,
//   setEducationState?: Dispatch<SetStateAction<IExperience[]>>,
//   setLanguageState?: Dispatch<SetStateAction<ILanguage[]>>,
//   setTechSkillsState?: Dispatch<SetStateAction<string[]>>
// ) {
//   useEffect(() => {
//     async function fetchAboutData() {
//       const response = await getAboutData();
//       setBioState && setBioState(response.data.bio);
//       setExperienceState && setExperienceState(response.data.experience);
//       setEducationState && setEducationState(response.data.education);
//       setLanguageState && setLanguageState(response.data.languages);
//       setTechSkillsState && setTechSkillsState(response.data.skills);
//     }

//     fetchAboutData();
//   });
// }
